import React from "react";
import i18n from "i18next";

import { Icon } from "../Common/Icon";
import KrugerLogo from "../../assets/Kruger-Logo.png";
import contactInfo from "../../data/ContactInfo.json";

const ContactCard = () => (
  <div className="help__card">
    <div className="help__contact-card-row">
      <img src={KrugerLogo} alt="logo kruger" className="help__contact-card-rep-image" />
      <div className="help__contact-card-rep-info">
        <span className="help__card-label">{i18n.t("help.itSupport")}</span>
        <a className="help__card-label --link" href={`tel:${contactInfo.supportPhoneNumber}`}>
          <Icon className="help__contact-card-icon" id="phone" />
          {contactInfo.supportPhoneNumber}
        </a>
        <a className="help__card-label --link" href={`mailto:${contactInfo.supportEmail}`}>
          <Icon className="help__contact-card-icon" id="email" />
          {contactInfo.supportEmail}
        </a>
      </div>
    </div>
  </div>
);

export default ContactCard;



// WEBPACK FOOTER //
// ./src/components/Help/ContactCard.js